import { useState, useEffect, useRef, useCallback } from "react";
import styles from "./Slider.module.scss";

/**
 * Переиспользуемый компонент слайдера
 * @param {Object} props
 * @param {string} props.label - Заголовок слайдера
 * @param {number} props.min - Минимальное значение
 * @param {number} props.max - Максимальное значение
 * @param {number} props.value - Текущее значение слайдера
 * @param {Function} props.onChange - Функция-обработчик изменения значения
 * @param {number} props.step - Шаг слайдера (опционально)
 * @param {string} props.className - Дополнительный CSS класс (опционально)
 * @returns {JSX.Element}
 */
const Slider = ({
  label,
  min,
  max,
  value,
  onChange,
  step = 0.01,
  className = "",
  hint = "",
}) => {
  const [currentValue, setCurrentValue] = useState(value);
  const rangeRef = useRef(null);

  const updateRangeProgress = useCallback(() => {
    if (rangeRef.current) {
      const percentage = ((currentValue - min) / (max - min)) * 100;
      rangeRef.current.style.setProperty("--range-progress", `${percentage}%`);
    }
  }, [currentValue, min, max]);

  useEffect(() => {
    setCurrentValue(value);
    updateRangeProgress();
  }, [value, updateRangeProgress]);

  const handleChange = (e) => {
    const newValue = parseFloat(e.target.value);
    setCurrentValue(newValue);
    onChange(newValue);
    updateRangeProgress();
  };

  return (
    <div className={`${styles.sliderContainer} ${className}`}>
      <div className={styles.sliderHeader}>
        <div className={styles.sliderLabel}>{label}</div>

        <div className={styles.sliderRange}>
          {min}-{max}
        </div>
      </div>

      <div className={styles.sliderControls}>
        <input
          ref={rangeRef}
          type="range"
          min={min}
          max={max}
          step={step}
          value={currentValue}
          onChange={handleChange}
          className={styles.sliderInput}
        />
        <div className={styles.sliderValue}>{currentValue}</div>
      </div>
      {hint && <small>{hint}</small>}
    </div>
  );
};

export default Slider;
